import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/bt_fpt_ai/p13_e1.mp3",
    autoPlay: true,
    video: "",
    isTuLuan:true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page13/Key/E1answerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    // inputSize: 81,
    textareaStyle: { width: 800, paddingTop: "5px" },
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `<span>
        Em gõ chữ vào mỗi dòng theo gợi ý ở từng phần như sau:<br><br>
        <b>Mở đầu:</b> Giới thiệu về câu chuyện.<br>
        <b>Triển khai:</b> Nêu lí do thích câu chuyện (Câu chuyện có nội dung gì hấp dẫn? Nhân vật nào thú vị? Chi tiết nào ấn tượng?...).<br>
        <b>Kết thúc:</b> Nêu suy nghĩ của em về câu chuyện<br><br>
        <div><video src="Audios/bt_fpt_ai/guide/p13_e1.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    titleQuestion: [
      {
        num: "",
        title: `
        <div style='margin-left:120px;font-size:30px;color:rgb(102 96 132)'>TÌM Ý CHO ĐOẠN VĂN NÊU Ý KIẾN</div>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    questions: [
      {
        title: `
            <div style='width:20cm;border: 5px solid rgb(29,193,215); background-color: rgb(230,249,253); padding:5px 10px;border-radius:20px;box-shadow:0px 2px 3px 4px gray'>
              Chọn một trong 2 đề dưới đây:<br>
              <b>Đề 1:</b>Viết đoạn văn nêu lý do yêu thích một câu chuyện về tình cảm gia đình mà em đã đọc hoặc đã nghe <br>
              <b>Đề 2:</b>Viết đoạn văn nêu lý do yêu thích một câu chuyện về con vật mà em đã đọc hoặc đã nghe <br>
            </div>   
            <div style='width:20cm;margin:20px 0px'>
            <div style='margin-left:20px margin-bottom: 30px'>
            <b>Mở đầu:</b><br>
              <textarea id='0' rows='3'></textarea>
            </div>
            <div style='margin-left:20px margin-bottom: 30px'>
            <b>Triển khai:</b><br>
              <textarea id='1' rows='3'></textarea>
            </div>
            <div style='margin-left:20px margin-bottom: 30px'>
            <b>Kết thúc:</b><br>
              <textarea id='2' rows='3'></textarea>
            </div><br>
         
            </div>
        `,
        answer: ["", "", ""],
      },
    ],
  },

  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/bt_fpt_ai/p13_e2.mp3",
    // autoPlay: true,
    isTuLuan:true,
    video: "",
    autoPlay: "true",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page13/Key/E2answerKey.png",
    component: T6,
    // textAlign: "center",
    // maxLength: 1,
    // inputSize: 81,
    stylesTextInput: {
      background: "none",
      borderBottom: "2px dotted gray",
      fontSize: 23,
      height: 30,
      // textTransform: 'uppercase',
    },
    textareaStyle: { width: 800, paddingTop: "5px" },
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `<span>
        Em gõ chữ vào chỗ chấm để điền thông tin về bản thân theo gợi ý.
        <div><video src="Audios/bt_fpt_ai/guide/p13_e2.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    titleQuestion: [
      {
        num: "",
        title: `
        <div style='margin-left:0px;font-size: 25px;color:rgb(102 96 132)'>Viết các thông tin vào chỗ trống để giới thiệu về bản thân em (nhớ viết hoa danh từ riêng)</div>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    questions: [
      {
        title: `
            <div style='border:4px solid rgb(29,193,215);border-radius:20px;margin-left:50px; padding:20px 40px; box-shadow:2px 5px 4px 3px gray'>
              <div style='display: flex'>
                <b >Họ và tên: <input id='0' width='450px'/></b>
                <b>Tuổi: <input id='1' width='150px'/></b>
              </div>  
                <b >Địa chỉ: <input id='2' width='722px'/></b><br>
                <b >Lớp, trường: <input id='3' width='660px'/></b><br>
                <b >Sở thích: <input id='4' width='703px'/></b><br>
                <b >Các thông tin khác: <input id='5' width='585px'/></b>
            </div>   
          
        `,
        answer: ["", "", "", "", "", ""],
      },
    ],
  },
};

export default json;
